import type { Locale } from '@fastnorth/i18next';
import type { ResourceLanguage } from 'i18next';

import enAU from '../../locales/en-AU.json';
import enCA from '../../locales/en-CA.json';
import enGB from '../../locales/en-GB.json';
import enUS from '../../locales/en-US.json';
import esMX from '../../locales/es-MX.json';
import frCA from '../../locales/fr-CA.json';
import idID from '../../locales/id-ID.json';
import jaJP from '../../locales/ja-JP.json';
import msMY from '../../locales/ms-MY.json';
import thTH from '../../locales/th-TH.json';
import viVN from '../../locales/vi-VN.json';
import zhHK from '../../locales/zh-HK.json';

type LanguagesResources = {
  [language in Locale]: ResourceLanguage;
};

export const defaultNS = 'translation';

export const defaultTranslations = enUS;

export const resources: LanguagesResources = {
  'en-AU': { translation: enAU },
  'en-CA': { translation: enCA },
  'en-GB': { translation: enGB },
  'en-US': { translation: enUS },
  'es-MX': { translation: esMX },
  'fr-CA': { translation: frCA },
  'id-ID': { translation: idID },
  'ja-JP': { translation: jaJP },
  'ms-MY': { translation: msMY },
  'th-TH': { translation: thTH },
  'vi-VN': { translation: viVN },
  'zh-HK': { translation: zhHK },
} as const;
